import { RuleExecutor, TopRule } from '../Rule';
import Formula from './Formula';
import Unit from './Unit';
import Zero from './Zero';
import Statement from '../Statement';

/**
 * The unit for `With`.
 */
class Top extends Unit {
  negated(): Formula {
    return new Zero();
  }

  equals(that: Formula): boolean {
    return that instanceof Top;
  }

  protected getSymbol(): string {
    return '⊤';
  }

  protected onClick(subgoal: Statement, executor: RuleExecutor) {
    const isRootRequirement = subgoal.hasRequirement(this.id);

    if (isRootRequirement) {
      return () => executor(new TopRule());
    }
  }
}

export default Top;
